import React from "react";
import HelpAndSupportTemplate from "../HelpAndSupport/HelpAndSupportTemplate";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useMediaQuery } from 'react-responsive';
import "./Faq.css"

const Faq = () => {
  let crumb = { name: "FAQs", link: "/help/faq" }
  const smallScreens = useMediaQuery({ maxWidth: 640 });

  return (
    <HelpAndSupportTemplate crumb={crumb}>
      
      <section className="margin-bottom-10">
        <h1 className="patua-one-regular fs-40 mb-0">Frequently Asked Questions</h1>
      </section>

      <section className="grid-col-12">
        <div className="grid-row grid-gap flex-justify-center">
          <div className="display-none tablet:display-block grid-col-4"></div>
          <div className={ smallScreens ? "grid-col-8 mt--105 w-100" : "grid-col-8 mt--105"}>
            <h2 className="page-title patua-one-regular">About Us</h2>
            <hr/>
            <Accordion className="mb-5">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="accordion-summary"
              >
                <Typography component="span" className="patua-one-regular fs-17">What is CDC Digital Gateway?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                CDC’s Digital Gateway is a digital inventory of CDC application programming interfaces (APIs) that enables both external partners and internal applications to seamlessly integrate their data with CDC’s core systems.
              </AccordionDetails>
            </Accordion>
            <Accordion className="mb-5">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
                className="accordion-summary"
              >
                <Typography component="span" className="patua-one-regular fs-17">What does Digital Gateway do?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                The Digital Gateway catalogs CDC APIs and services under one roof to ensure they are standardized, secure, accessible, and socialized for public use.
              </AccordionDetails>
            </Accordion>
            <Accordion className="mb-5">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3-content"
                id="panel3-header"
                className="accordion-summary"
              >
                <Typography component="span" className="patua-one-regular fs-17">What is the purpose of the Digital Gateway?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                Our mission is to accelerate innovation in public health via data-driven decision-making by providing a centralized hub, supported by real-time public health data, for those working with CDC APIs.
              </AccordionDetails>
            </Accordion>

            <h2 className="margin-top-5 patua-one-regular">Our APIs (Individual APIs and Products)</h2>
            <hr/>
            <Accordion className="mb-5">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel4-content"
                id="panel4-header"
                className="accordion-summary"
              >
                <Typography component="span" className="patua-one-regular fs-17">Where can I access individual APIs?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                You can access individual APIs hosted on Digital Gateway by visiting our API library. Browse the API library below to discover the APIs you need to transport, validate, and observe CDC public health data. <br /><br />
                As the Digital Gateway grows, our API library will grow too.              
              </AccordionDetails>
            </Accordion>
            <Accordion className="mb-5">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5-content"
                id="panel5-header"
                className="accordion-summary"
              >
                <Typography component="span" className="patua-one-regular fs-17">What is the Digital Gateway API Library?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                The Digital Gateway API Library is a one-stop shop for users who want to access individual APIs. Visit this repository to view and sort through our available APIs to find exactly what you need.              
              </AccordionDetails>
            </Accordion>
            <Accordion className="mb-5">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel6-content"
                id="panel6-header"
                className="accordion-summary"
              >
                <Typography component="span" className="patua-one-regular fs-17">What are the products listed on the Digital Gateway?</Typography>
              </AccordionSummary>
              <AccordionDetails>
                You can access individual APIs hosted on the Digital Gateway by visiting our API library. Browse the API library below to discover the APIs you need to transport, validate, and observe CDC public health data.              
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      </section>
    </HelpAndSupportTemplate>
  );
};

export default Faq;
